module.exports = __webpack_public_path__ + "img/top2.0df0b9f.png";